module.exports = __webpack_public_path__ + "media/img/manual-testing/testing-process-img-e33e1643c82d7358bd12e7b5c976ba4d.svg";